import React, { useState } from 'react';
import {
    Card,
    CardContent,
    CardHeader,
    Typography,
    Tabs,
    Tab,
    Box,
    Grid,
    Button,
    Avatar,
    IconButton,
    Select,
    MenuItem,
    FormControl,
    FormControlLabel,
    Checkbox,
    ImageList,
    ImageListItem,
    Divider,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Chip,
    Paper,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import {
    Settings,
    Twitter,
    Instagram,
    Github,
    Link2,
    Heart,
    ExternalLink,
    MapPin,
    Calendar,
    Users,
    Image as ImageIcon,
    MessageCircle,
    Palette,
    BookOpen,
    Star,
    Users2,
    Crown,
    QrCode,
    ArrowForwardIos as ArrowForwardIosIcon
} from 'lucide-react';
import ApiFetch from '../ApiFetch';
import * as ImageUtil from '../../service/ImageUtil';
import { LoginInfo } from '../../App';
import { isFollow, followDelete, followPost, getFollowList, getFollowerList } from '../../service/FollowService';
import parse, { domToReact } from 'html-react-parser'
import { Link, useNavigate, useParams } from 'react-router-dom';
import FavoriteIcon from '../FavoriteIcon';
import Dialog from '../Dialog';
import Footer from '../Footer';
import Header from '../Header';
import FollowButton from '../FollowButton';
import RegistConfirm from '../RegistConfirm';
import { useTranslation } from "react-i18next";
import Thumb from '../common/Thumb';
import SettingPopup from '../SettingPopup';
import RankingRecordPopup from '../RankingRecordPopup';
import SeriesEditPopup from '../SeriesEditPopup';
import UserManageInfo from '../UserManageInfo';
import PointSend from '../PointSend';
import UserMark from '../UserMark';
import { arrayShuffle, imgPath } from '../../service/CommonUtil';
import MuiButton from '@mui/material/Button'
import PlanConfirmDialog from '../common/PlanConfirmDialog';
import Plan from '../Plan';
import CommonDialog from '../common/CommonDialog';
import CharacterProfileCard from '../common/CharacterProfileCard';
import QRCode from "react-qr-code";
import { QrCode2, QrCode2Outlined } from '@mui/icons-material';
// Heroセクション用のスタイル
const HeroContainer = styled('div')(({ theme }) => ({
    position: 'relative',
    height: '500px',
    overflow: 'hidden',
    background: 'linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.8) 100%)',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
         backgroundImage: 'url(/api/placeholder/1920/1080)', // 仮の背景画像
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        zIndex: -1,
    },
    display: 'flex',
    alignItems: 'flex-end',
    paddingBottom: theme.spacing(20),
    [theme.breakpoints.down('md')]: {
        height: 'auto',
        paddingBottom: theme.spacing(8),
    },
}));

const ProfileAvatar = styled(Avatar)(({ theme }) => ({
    width: theme.spacing(16),
    height: theme.spacing(16),
    border: `4px solid ${theme.palette.common.white}`,
    boxShadow: theme.shadows[8],
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
        transform: 'scale(1.05)',
    },
    '& .MuiAvatar-img': {
        objectFit: 'cover',
    },
    position: 'relative',
    '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: theme.spacing(2),
        height: theme.spacing(2),
        borderRadius: '50%',
        backgroundColor: theme.palette.success.main,
        border: `4px solid ${theme.palette.common.white}`,
    }
}));

const ActionButtons = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        marginTop: theme.spacing(2),
    }
}));


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`user-profile-tabpanel-${index}`}
            aria-labelledby={`user-profile-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `user-profile-tab-${index}`,
        'aria-controls': `user-profile-tabpanel-${index}`,
    };
}


const UserProfile3 = (props) => {
    const {t} = useTranslation()
    const navigate = useNavigate();
    const saveSvgAsPng = require("save-svg-as-png")
    // ログイン情報
    const {loginInfo,setLoginInfo} = React.useContext(LoginInfo)
    let param = useParams();
    let userIdOrDisplayId = param.id
    let tab = param.tab

    const [value, setValue] = useState(0);
    const [userId,setUserId] = useState("")
    const [link,setLink] = useState("")
     // 削除対象選択情報
     const [item, selectItem] = useState('');
     const [deleted, setDeleted] = useState('');
 
     // 検索情報
     const [page,setPage] = useState(0)
     const [communityPage,setCommunityPage] = useState(1)
     const [followPage,setFollowPage] = useState(1)
     const [followerPage,setFollowerPage] = useState(1)
     const [characterPage,setCharacterPage] = useState(0)
 
     const [userInfo, setUserInfo] = useState([])
     const [osusumeImageList,setOsusumeImageList] = useState([...Array(0)])
     const [imageList,setImageList] = useState([...Array(0)])
     const [order,setOrder] = useState(param.order || "post_desc")
     const [unitSell,setUnitSell] = useState(false)
     const [membership,setMembership] = useState(false)
     const [message,setMessage] = useState('')
     const [communityMessage,setCommunityMessage] = useState('')
     const [follow,setFollow] = useState(false)
 
     const [characterList,setCharacterList] = useState([...Array(0)])
 
     // コミュニティ投稿用画像の一時保持
     const [communityImage,setCommunityImage] = useState("")
     // コミュニティ情報
     const [communityImageList,setCommunityImageList] = useState([])
 
     // フォロー
     const [followList, setFollowList] = useState([])
     const [followerList, setFollowerList] = useState([])
     const [followCount, setFollowCount] = useState(0)
     const [followerCount, setFollowerCount] = useState(0)
     const [subscriptionCount, setSubscriptionCount] = useState(0)
 
     // ポイント
     const [point,setPoint] = useState(0)
     const [totalPointsUsed,setTotalPointsUsed] = useState(0)
     const [postGetPoint,setPostGetPoint] = useState(0)
     const [basePoint,setBasePoint] = useState(0)
     const [numberOfUnitsUnderOperation,setNumberOfUnitsUnderOperation] = useState(0)
 
     // 投稿数
     const [imageCount,setImageCount] = useState(0)
     // 投稿枚数
     const [imageDetailCount,setImageDetailCount] = useState(0)
     // 合計閲覧数
     const [pvAllCount,setPVAllCount] = useState(0)
     // 過去3ヵ月間の平均PV
     const [pv3MonthCount,setPV3MonthCount] = useState(0)
     // 過去3ヵ月間の平均PV順位
     const [pv3MonthRank,setPV3MonthRank] = useState(0)
     // 過去3ヵ月間の平均いいね数
     const [favorite3MonthCount,setFavorite3MonthCount] = useState(0)
     // 合計いいねされた数
     const [favoriteCount,setFavoriteCount] = useState(0)
    // 合計いいねした数
     const [favoritedCount,setFavoritedCount] = useState(0)
     // 画像生成回数
     const [imageGenrationCount,setImageGenrationCount] = useState(0)
     // プラン状態
    const [planStatus,setPlanStatus] = useState([])
 
     // 設定
     const [showSetting,setShowSetting] = useState(false)
     // 実績
     const [showUserAchievements,setShowUserAchievements] = useState(false)
     // QRコード
    const [showQRCode,setShowQRCode] = useState(false)
     // ランキング入賞履歴
     const [showRankingRecord,setShowRankingRecord] = useState(false)
         
     // プラン一覧
     const [planList,setPlanList] = useState([])
 
     // ダイアログ
    const [show, setShow] = useState(false)
     const [dialogTitle, setDialogTitle] = useState("")
     const [dialogMessage, setDialogMessage] = useState("")
     const [okButtonShow,setOkButtonShow] = useState(false)

    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
   
        async function getUserInfo(userIdOrDisplayId){
            return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/"+userIdOrDisplayId)
                .then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function getImage(userId,order,page){
            return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/user/"+userId+"/"+order+"/"+page).then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function getCharacter(userId,order,page){
            return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/character/user/"+userId+"/"+order+"/"+page).then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function getOsusumeImage(userId,page){
            return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/userOsusume/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function getCommunityImageList(userId,page){
            return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/community/user/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function deleteCommunityImage(groupId){
            return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/community/user/"+groupId).then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function getSeriesList(userId){
            return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/series/list/"+userId).then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function deleteSeries(seriesId){
            return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/series",{seriesId:seriesId}).then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function refererUser(displayIdOrUserId){
            return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/regist/referrer",{displayIdOrUserId:displayIdOrUserId}).then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function updateAgeLimitByAdmin(groupId,ageLimit){
            return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/ageLimit/"+groupId,{ageLimit:ageLimit})
                .then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function updateStyleOfPaintingByAdmin(groupId,style){
            return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/style/"+groupId,{style:style})
                .then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function sendMosaicNoticeByAdmin(groupId){
            return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/mosaic/"+groupId)
                .then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function updateStatusByAdmin(userId,status,reason){
            return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/login/status/"+userId,{status:status,reason:reason})
                .then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function searchBanByAdmin(userId){
            return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userScore/searchBan/"+userId,{})
                .then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function aiGenerateSuspendByAdmin(userId){
            return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/aiGenerateSuspend/"+userId,{})
                .then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        async function getPlanList(userId){
            return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/plan/list/"+userId)
                .then((r)=>r.json().then((json)=>{
                return json
            }))
        }
        function clearAllInterval(){
            for (var i = 1; i < 99999; i++)
                window.clearInterval(i)
        }
           // アップロード処理
    function upload(files){
        let fapi = new ApiFetch()
        let fd = new FormData();
        fd.append("text",document.getElementById("text").value)
        for(let i = 0;i < files.length;i++){
            fd.append("file[]",files[i])
        }
        fapi.fileUpload(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/upload/community",fd).then((r)=>{
            r.json().then(json=>{
                if(json.result){
                    let text = document.getElementById("text")
                    let file = document.getElementById("file")
                    text.value = ""
                    file.value = ""

                    setCommunityImage("")
                    dialog("投稿完了","投稿が完了しました。")

                    getCommunityImageList(userId,1).then(r=>{
                        if(r.result){
                            if(r.data.length > 0){
                                setCommunityMessage("")
                            } else {
                                setCommunityMessage("投稿がありません。")
                            }
                            setCommunityImageList(r.data)
                        }
                    })
                } else {
                    setOkButtonShow(false)
                    dialog("エラー",json.errors.join("\r\n"))
                }
            })
        }).then(r=>{

        })
    }

   // 投稿遅延ロード
   const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.05
  }
const observer = new IntersectionObserver((entries,observer)=>{
    entries.forEach(entry => {
        if(entry.intersectionRatio > 0){
            const imgEl = entry.target;
            //imgEl.src = imgEl.dataset.src;          
            observer.unobserve(entry.target)
            // ロードした部分まで進んだら追加読み込み
            if(imgEl.dataset.type === "community" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (communityPage * 10 - 1) ){
                setCommunityPage(communityPage+1)
                getCommunityImageList(userId,communityPage+1).then(r => {
                    if(r.result){
                        setCommunityImageList(communityImageList.concat(r.data))
                    }
                })
            }
            if(imgEl.dataset.type === "follow" && imgEl.dataset.observe === "0" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (followPage * 6 - 1) ){
                imgEl.dataset.observe = "1"
                setFollowPage(followPage+1)
                getFollowList(userId,followPage+1).then(r => {
                    if(r.result){
                        setFollowList(followList.concat(r.data))
                    }
                })
            }
            if(imgEl.dataset.type === "follower" && imgEl.dataset.observe === "0" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (followerPage * 6 - 1) ){
                imgEl.dataset.observe = "1"
                setFollowerPage(followerPage+1)
                getFollowerList(userId,followerPage+1).then(r => {
                    if(r.result){
                        setFollowerList(followerList.concat(r.data))
                    }
                })
            }
          }
    })
}, options);
    
    React.useEffect(() =>{
        clearAllInterval()
        let currentPage = 1
        if(param.page === undefined){
            currentPage = 1
        } else {
            currentPage = parseInt(param.page)
        }
        setPage(currentPage)
        setCharacterPage(1)

        getUserInfo(userIdOrDisplayId).then(json => {
            if(json.result){
                // タイトル設定
                document.querySelector("title").textContent = json.user_name + " - ourt AI"
                setUserInfo(json)
                setFollowCount(json.follow)
                setFollowerCount(json.follower)
                setSubscriptionCount(json.subscription)
                setImageCount(json.image)
                setImageDetailCount(json.image_detail)
                setPVAllCount(json.pv)
                setPV3MonthCount(json.pv_3month)
                setPV3MonthRank(json.pv_3month_rank)
                setFavorite3MonthCount(json.favorite_3month)

                // 最大1枚25ポイント
                let avg = json.pv_3month
                let p = 0
                if(avg <= 500){
                    p = Math.floor(avg / 5) // 5閲覧数に対して1ポイント増加。最大50ポイント
                } else {
                    p = 50
                }
                setPostGetPoint(p*10)
                setBasePoint(json.base_point)
                setNumberOfUnitsUnderOperation(json.number_of_units_under_operation)
                setFavoriteCount(json.favorite)
                setFavoritedCount(json.favorited)
                setPoint(json.point.point)
                setTotalPointsUsed(json.point.total_points_used)
                setImageGenrationCount(json.image_generation_count)
                setPlanStatus(json.plan_status)

                let targetUserId = json.user_id
                setUserId(targetUserId)
                isFollow(targetUserId,() => {}).then(r => {
                    setFollow(r)
                })
        
                // シリーズ
                getSeriesList(targetUserId).then(r => {
                    if(r.result){
                        setSeriesList(r.data)
                    }
                })
                setFollowPage(1)
                setFollowerPage(1)
                getFollowList(targetUserId,1).then(r => {
                    if(r.result){
                        setFollowList(r.data.concat([]))
                    } else {
                        setFollowList([].concat([]))
                    }
                })
                getFollowerList(targetUserId,1).then(r => {
                    if(r.result){
                        setFollowerList(r.data.concat([]))
                    } else {
                        setFollowerList([].concat([]))
                    }
                })
                setLink("https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Emention%7Ctwgr%5Eourt_official&text="
                + encodeURIComponent(json.user_name + "さんのマイページ\n" + ApiFetch.API_PROTOCOL+"//ourt-ai.work/user/"+(json.display_id.length > 0 ? json.display_id : json.user_id) + "\n#アワートAI #AIイラスト #AIart")
                )
            } else {
                dialog(t("common.error"),json.errors)
            }
        })
    },[userIdOrDisplayId])

    // ページ遷移
    React.useEffect(() =>{
        // 初期処理では取得せず、ページ番号が確定してから取得する
        if(page > 0 && userId !== ""){
            getImageList(userId,order,page)
        }
    },[userId,order,page])

    function getImageList(userId,order,page){
        getImage(userId,order,page).then(json => {
            if(json.result){
                if(json.data.length > 0){
                    setMessage("")
                } else {
                    setMessage("投稿がありません。")
                }
                // スクロールを最上位に戻す
                //window.scrollTo({top:0,left:0,behavior:"instant"})
                setImageList(json.data)
            }
        })
    }

    // ページ遷移
    React.useEffect(() =>{
        // 初期処理では取得せず、ページ番号が確定してから取得する
        if(characterPage > 0 && userId !== ""){
            getCharacterList(userId,order,characterPage)
        }
    },[userId,order,characterPage])

    function getCharacterList(userId,order,characterPage){
        getCharacter(userId,order,characterPage).then(json => {
            if(json.result){
                // スクロールを最上位に戻す
                //window.scrollTo({top:0,left:0,behavior:"instant"})
                setCharacterList(json.data)
            }
        })
    }

     // ログインユーザー自身のページを表示しているか？
     const [isMe,setIsMe] = useState(false)

     React.useEffect(() => {
         let entered = false
         if(loginInfo.result && userInfo.user_id !== undefined && loginInfo.userId !== userInfo.user_id){
             // 自分自身以外のページを表示しているとき
             setIsMe(false)
             setTabKey("osusume")
             getOsusumeImage(userInfo.user_id,page).then(json => {
                 if(json.result){
                     // スクロールを最上位に戻す
                     window.scrollTo({top:0,left:0,behavior:"instant"})
                     setOsusumeImageList(arrayShuffle(json.data))
                 }
             })
             entered = true
         } else if (loginInfo.result && loginInfo.userId === userInfo.user_id){
             // 自分のページを表示しているとき
             setIsMe(true)
             setTabKey("account")
             entered = true
         }
         if(tab !== undefined){
             handleTabSelect(tab)
             setTabKey(tab)
         } else {
             if(!entered){
                 getPlanList(userInfo.user_id).then(r => {
                     if(r.result){
                         setPlanList(r.data)
                     } else {
                         setPlanList([].concat())
                     }
                 })
                 setTabKey("account")
             }
         }
     },[loginInfo,userInfo,tab])

    // 画像遅延ロード
    React.useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageList,communityImageList,followList,followerList])

    const [tabKey,setTabKey] = useState(false)

    function handleTabSelect(e){
        setTabKey(e)
        if(e === "community"){
            if(communityImageList.length === 0){
                getCommunityImageList(userId,1).then(r=>{
                    if(r.result){
                        if(r.data.length > 0){
                            setCommunityMessage("")
                        } else {
                            setCommunityMessage("投稿がありません。")
                        }
                        setCommunityImageList(r.data)
                    }
                })
            }
        } else if(e === "follow"){
            if(followList.length === 0){
                if(followPage > 1){
                    getFollowList(userId,1).then(r => {
                        if(r.result){
                            setFollowList(r.data.concat([]))
                        } else {
                            setFollowList([].concat([]))
                        }
                    })
                }
            }
        } else if(e === "follower"){
            if(followerList.length === 0){
                if(followerPage > 1){
                    getFollowerList(userId,1).then(r => {
                        if(r.result){
                            setFollowerList(r.data)
                        } else {
                            setFollowerList([].concat())
                        }
                    })
                }
            }
        } else if(e === "plans"){
            if(planList.length === 0){
                getPlanList(userId).then(r => {
                    if(r.result){
                        setPlanList(r.data)
                    } else {
                        setPlanList([].concat())
                    }
                })
            }
        }
    }

     // 削除ボタン
     let okButton
     if(!okButtonShow){
         okButton = ""
     } else {
         okButton = <Button onClick={() => {
             setShow(false)
             if(item.type === "follow"){
                 followDelete(userInfo.user_id,dialog).then(r=>{
                     if(r){
                         setFollow(false)
                     }
                     setOkButtonShow(false)
                 })
             } else if(item.type === "community_image"){
                 deleteCommunityImage(item.id).then(r=>{
                     if(r.result){
                         setDeleted(item.id)
 
                         getCommunityImageList(userId,1).then(r=>{
                             if(r.result){
                                 if(r.data.length > 0){
                                     setCommunityMessage("")
                                 } else {
                                     setCommunityMessage("投稿がありません。")
                                 }
                                 setCommunityImageList(r.data)
                             }
                         })
                     } else {
                         setOkButtonShow(false)
                         dialog("エラー",r.errors)
                     }
                 })
             }
         }}>OK</Button>
     }
     let followButton
     /**
      * 以下の場合フォローボタンを表示しない
      * 投稿者本人の場合
      * 投稿者が匿名の場合
      */
     if(!(loginInfo.userId === userInfo.user_id) && userInfo.user_id !== "anonymous"){
         if(follow){
             followButton = <MuiButton className='mb-2' variant='outlined' color="error" onClick={(e) => {
                 selectItem({type:"follow"})
                 setOkButtonShow(true)
                 dialog("確認","フォローを解除しますか？")
             }}>フォロー済み</MuiButton>
         } else {
             followButton = <MuiButton className='mb-2' variant='contained' color="error" onClick={(e) => {
                 if(loginInfo.userId === userInfo.user_id){
                     dialog("エラー","自分自身はフォローできません。")
                     return
                 }
                 followPost(userInfo.user_id,dialog).then(r=>{
                     if(r){
                         setFollow(true)
                     }
                 })
             }}>フォローする</MuiButton>
         }
     }
     function seriesUpdateHandler(seriesId){
        // シリーズ
        getSeriesList(userId).then(r => {
            if(r.result){
                setSeriesList(r.data)
            }
        })
    }
    const [seriesId,setSeriesId] = useState()
    const [showShowSeriesEdit,setShowSeriesEdit] = useState(false)
    const [seriesList,setSeriesList] = useState([])
    const [showPointSend,setShowPointSend] = useState(false)
    const tagReplace = (node) => {
        if (node.name === 'span' && node.attribs.tag !== undefined) {
          return (
            <span {...node.attribs} onClick={() => navigate("/search_users?tag="+node.attribs.tag)} style={{color:"#00AAFF",cursor:"pointer"}}>
              #{ domToReact(node.children) }
            </span>
          )
        }
        if (node.name === 'span' && node.attribs.href !== undefined) {
            return (
              <span {...node.attribs} onClick={() => navigate("/image/"+node.attribs.href)} style={{color:"#00AAFF",cursor:"pointer"}}>
                { domToReact(node.children) }
              </span>
            )
        }
        if (node.name === 'a') {
            return (
              <a href={"/jump/" + encodeURIComponent(node.attribs.href)}>{node.attribs.href}</a>
            )
        }
    }
        // 管理用
    const [adminSelectItem,setAdminSelectItem] = useState("account_suspend")

    return (
        <Box sx={{
            width: '100%',
            minHeight: '100vh',
            background: 'linear-gradient(to bottom right, #f0f0f0, #f5f5f5)',
        }}>
             {showSetting ? (<SettingPopup switch={setShowSetting} />) : ""}
        {showRankingRecord ? (<RankingRecordPopup switch={setShowRankingRecord} userId={userId} />) : ""}
        {showShowSeriesEdit ? <SeriesEditPopup switch={setShowSeriesEdit} seriesId={seriesId} onUpdate={seriesUpdateHandler} /> : ""}
        {showPointSend ? <PointSend userId={userInfo.user_id} userName={userInfo.user_name} dialog={dialog} switch={setShowPointSend} /> : ""}
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} button={okButton} />
        <Header />
            <Box sx={{
                maxWidth: '1280px',
                margin: '0 auto',
                padding: (theme) => theme.spacing(0, 4),
            }}>
                 {loginInfo.role && loginInfo.role.find(d => d.role_div === "admin" || d.role_div === "moderator") ? (
            <Paper style={{width:"400px",border:"1px solid red"}} className="mb-3 p-3">
                <FormControl fullWidth>
                  <Select className="mb-3" value={adminSelectItem} style={{}}
                      onChange={(e) => setAdminSelectItem(e.target.value)}
                  >
                      <MenuItem value="アカウント" disabled>【アカウント】</MenuItem>
                      <MenuItem value="search_ban" style={{color:"red"}}>新着や検索から除外</MenuItem>
                      <MenuItem value="ai_generate_suspend" style={{color:"red"}}>AI生成機能の利用制限措置</MenuItem>
                      <MenuItem value="account_suspend" style={{color:"red"}}>一時停止(利用規約違反)</MenuItem>
                      <MenuItem value="account_suspend_child_porn_post" style={{color:"red"}}>一時停止(児童ポルノまたは類似物の投稿)</MenuItem>
                      <MenuItem value="account_suspend_child_porn_generate" style={{color:"red"}}>一時停止(児童ポルノまたは類似物の生成)</MenuItem>
                      <MenuItem value="account_suspend_copyright" style={{color:"red"}}>一時停止(著作権侵害)</MenuItem>
                      <MenuItem value="account_permanently_frozen" style={{color:"red"}}>永久凍結</MenuItem>
                  </Select>
                </FormControl>
                <MuiButton  variant='contained' style={{}}
                    onClick={(e) => {
                        if(adminSelectItem !== "ai_generate_suspend" && adminSelectItem !== "search_ban"){
                            let status = -1
                            let reason = -1
                            if(adminSelectItem === "account_suspend"){
                                status = 3 // 一時停止
                                reason = 1 // 利用規約違反
                            } else if(adminSelectItem === "account_suspend_child_porn_post"){
                                status = 3 // 一時停止
                                reason = 2 // 写実的な児童ポルノコンテンツの投稿
                            } else if(adminSelectItem === "account_suspend_child_porn_generate"){
                                status = 3 // 一時停止
                                reason = 3 // 写実的な児童                                pornコンテンツの生成
                            } else if(adminSelectItem === "account_suspend_copyright"){
                                status = 3 // 一時停止
                                reason = 4 // 著作権侵害
                            } else if(adminSelectItem === "account_permanently_frozen") {
                                status = 4 // 永久凍結
                            }
                            updateStatusByAdmin(userInfo.user_id,status,reason).then(r => {
                                if(r.result){
                                    dialog("確認","アカウントを「"+r.data.accountReturn+"」しました。")
                                } else {
                                    dialog("エラー",r.errors)
                                }
                            })
                        } else if(adminSelectItem === "search_ban"){
                            searchBanByAdmin(userInfo.user_id).then(r => {
                                if(r.result){
                                    dialog("確認","新着や検索から除外しました。")
                                } else {
                                    dialog("エラー",r.errors)
                                }
                            })
                        } else if(adminSelectItem === "ai_generate_suspend"){
                            aiGenerateSuspendByAdmin(userInfo.user_id).then(r => {
                                if(r.result){
                                    dialog("確認","AI生成機能の利用を制限しました。")
                                } else {
                                    dialog("エラー",r.errors)
                                }
                            })
                        }
                        
                    }}
                >実行(管理者権限)</MuiButton>
                <MuiButton variant='contained' style={{marginLeft:"10px"}} onClick={() => dialog("統計情報",<UserManageInfo userIdOrDisplayId={userInfo.user_id} dialog={dialog} change={userInfo.user_id} />)}>管理情報</MuiButton>
            </Paper>
        ) : ""}
            </Box>
            {/* ヒーローセクション */}
            <HeroContainer>
                <Box container sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    height: '100%',
                    padding: (theme) => theme.spacing(0, 4),
                    width: { xs: '100%', md: 'calc(100% - 40px)' },
                    maxWidth: '1280px',
                    margin: '0 auto',
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 8, mb: { xs: 2, md: 0 }, flexDirection: { xs: 'column', md: 'row' } }}>
                        {/* プロフィール画像 */}
                        <ProfileAvatar src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+userId+".jpg?"+userInfo.hash} alt={userInfo?.user_name} />

                        {/* プロフィール情報 */}
                        <Box sx={{ flex: 1, color: 'white' }}>
                            <Typography variant="h4" fontWeight="bold" mb={1}><ruby> {userInfo.user_name} <rp>(</rp><rt>{userInfo.user_name_kana}</rt><rp>)</rp> </ruby> <UserMark sms_auth={userInfo.sms_auth} role={userInfo.role} plan={userInfo.plan} beginner={userInfo.beginner} identity_confirmed={userInfo.identity_confirmed} moderator_badge_display_flag={userInfo.moderator_badge_display_flag} dialog={dialog} /></Typography>
                            <Typography variant="body1" color="grey.300" mb={3} maxWidth={800}>
                            {userInfo.user_id ? parse(userInfo.self_introduction.replace(/\n|\r\n|\r/g,'<br/ >').replace(/(https?:\/\/[\w!?/+\-_~;.,*&@#$%()'[\]]+)/g,'<a href="$1">$1</a>').replace(/[#＃]{1}([Ａ-Ｚａ-ｚA-Za-z一-鿆0-9０-９ぁ-ヶｦ-ﾟー._-・]?[^　#＃\r\n]+)/g,'<span tag="$1">$1</span>'),{replace:tagReplace}) : ""}
                            </Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 2 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <MapPin size={16} />
                                    <Typography variant="body2">{t("common.registered")} {new Date(userInfo.create_datetime).getFullYear() + "/" + (new Date(userInfo.create_datetime).getMonth() + 1)}</Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, alignItems: 'center' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Users size={16} />
                                    <Typography variant="body2">{followCount} {t("common.follow")}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                   <Users2 size={16} />
                                    <Typography variant="body2">{followerCount} {t("common.follower")}</Typography>
                                </Box>
                                {subscriptionCount > 0 ? (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Crown size={16} />
                                         <Typography variant="body2">{subscriptionCount} {t("common.subscription")}</Typography>
                                    </Box>
                                ) : ""}
                                
                                {userInfo.id_auth === 1 ? (<Chip label={"本人確認済"} size="small" sx={{ backgroundColor: 'rgba(200,200,200,0.2)' }} />) : (<Chip label="本人確認未提出" size="small" sx={{ backgroundColor: 'rgba(200,200,200,0.2)' }} />)}
                            </Box>
                            {/* QRコードボタン */}
                            <Button
                                startIcon={<QrCode style={{ width: 16, height: 16 }} />}
                                onClick={() =>  setShowQRCode(true) }
                                variant="text"
                                sx={{ mt: 2, color: 'rgba(255,255,255,0.8)', '&:hover': { color: 'white' } }}
                            >
                                プロフィールのQRコードを表示
                            </Button>
                            {showQRCode ? <CommonDialog open={showQRCode} onClose={() => setShowQRCode(false)} content={<Container className='text-center'><h5>{userInfo.user_name} さんのマイページ</h5><QRCode value={'https://ourt-ai.work/user/'+userId} fullScreen={false} id='qr' /><br /><MuiButton className='mt-3' variant='contained' onClick={() => saveSvgAsPng.saveSvgAsPng(document.getElementById("qr"), "qr.png", {scale: 10})}>保存</MuiButton></Container>} /> : ""}
                        </Box>
                         {/* アクションボタン */}
                         <ActionButtons>
                         {followButton}
                            {loginInfo.userId === userInfo.user_id || userInfo.user_id === "anonymous" ? "" : (
                                        <>
                                        <IconButton sx={{ backgroundColor: 'rgba(255,255,255,0.1)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' } }}
                                            onClick={() => setShowPointSend(true)}
                                        ><Heart style={{ color: 'white' }} /></IconButton>
                                        </>
                                    )}
                            <IconButton sx={{ backgroundColor: 'rgba(255,255,255,0.1)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' } }}>
                                <MessageCircle size={20} style={{ color: 'white' }} />
                            </IconButton>
                        </ActionButtons>
                    </Box>
                </Box>
            </HeroContainer>

            {/* メインコンテンツ */}
            <Box sx={{
                maxWidth: '1280px',
                margin: '0 auto',
                padding: (theme) => theme.spacing(0, 4),
                mt: -12,
            }}>
                <Paper sx={{ backgroundColor: 'rgba(255, 255, 255, 0.6)', backdropFilter: 'blur(10px)', borderRadius: 3, boxShadow: 5, p: 4 }}>

                    <Tabs value={value} onChange={handleChange} aria-label="user profile tabs"
                        sx={{
                            marginBottom: 4,
                            '& .MuiTabs-indicator': {
                                backgroundColor: 'primary.main'
                            },
                            '& .MuiTab-root': {
                                color: (theme) => theme.palette.text.primary,
                                '&.Mui-selected': {
                                    color: (theme) => theme.palette.primary.contrastText,
                                    backgroundColor: (theme) => theme.palette.primary.main,
                                },
                            },
                        }}
                    >
                        <Tab label={<><ImageIcon style={{ width: 16, height: 16, marginRight: 8 }} />{t("common.illust")}</>} {...a11yProps(0)} />
                        {isMe || loginInfo.userId === undefined ? "" : <Tab label={<><Star style={{ width: 16, height: 16, marginRight: 8 }} />{t("osusume.title")}</>} {...a11yProps(1)} />}
                        <Tab label={<><Palette style={{ width: 16, height: 16, marginRight: 8 }} />{t("character.title")}</>} {...a11yProps(2)} />
                        <Tab label={<><BookOpen style={{ width: 16, height: 16, marginRight: 8 }} />{t("common.series")}</>} {...a11yProps(3)} />
                        <Tab label={<><Users2 style={{ width: 16, height: 16, marginRight: 8 }} />{t("common.community")}</>} {...a11yProps(4)} />
                        {userInfo.user_id !== loginInfo.userId && userInfo.id_auth === 1 || userInfo.user_id === loginInfo.userId ? (
                             <Tab label={<><Crown style={{ width: 16, height: 16, marginRight: 8 }} />{t("common.plan")}</>} {...a11yProps(5)} />
                        ) : ""}
                        <Tab label={<><Users style={{ width: 16, height: 16, marginRight: 8 }} />{t("common.trackRecord")}</>} {...a11yProps(6)} />
                    </Tabs>

                    {/* ギャラリータブ */}
                    <TabPanel value={value} index={0}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, mb: 4 }}>
                            <FormControl sx={{ minWidth: 120 }}>
                                <Select defaultValue="post_desc"
                                onChange={(e) => {
                                    setOrder(e.target.value)
                                }}>
                                    <MenuItem value="post_desc">{t("sort.newPost")}</MenuItem>
                                    <MenuItem value="post_asc">{t("sort.oldPost")}</MenuItem>
                                    <MenuItem value="favorite_desc">{t("sort.favorite")}</MenuItem>
                                    <MenuItem value="pv_desc">{t("sort.views")}</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControlLabel control={<Checkbox onChange={(e) => setUnitSell(e.target.checked)} />} label="単品販売" />
                            <FormControlLabel control={<Checkbox onChange={(e) => setMembership(e.target.checked)} />} label="メンバーシップ" />
                        </Box>
                        <MuiButton variant='outlined' className='m-1' onClick={() => setPage(1)}>1ページ目へ</MuiButton>
                         {userInfo.user_id === loginInfo.userId ? <MuiButton variant='outlined' className='m-1' onClick={() => navigate("/manage")}>全ての投稿を表示</MuiButton> : ""}
                        <ImageList sx={{ gridAutoRows: 200 }} cols={{ xs: 2, md: 3, lg: 4 }} gap={8}>
                             {message}
                            {imageList.filter(d => {
                                if(!unitSell && !membership) return true
                                if(unitSell && d.unit_amount > 0) return true
                                if(membership && d.limit_div !== "public") return true
                            }).map((data,i) => {
                                if(i === 100){
                                    return ""
                                }
                            return <Thumb data={data} i={i} dialog={dialog} key={i} userInfoHidden={true} list={imageList} listName={userInfo.user_name} />
                            })}
                        </ImageList>
                        <Container className='d-flex justify-content-between' style={{width:"200px"}}>
                        {page > 1 ? (
                                <MuiButton variant='contained' onClick={() => {
                                    let p = page - 1
                                    setPage(p)
                                    //navigate("/user/" + userId + "/" + order + "/" + p)
                                    getImageList(userId,order,p)
                                } }>{t("common.prev")}</MuiButton>
                            ) : <MuiButton variant='contained' disabled>{t("common.prev")}</MuiButton>}
                        {imageList.length > 100 ? (
                                <MuiButton variant='contained' onClick={() => {
                                    let p = page + 1
                                    setPage(p)
                                    //navigate("/user/" + userId + "/" + order + "/" + p)
                                    getImageList(userId,order,p)
                                } }>{t("common.next")}</MuiButton>
                            ) : <MuiButton variant='contained' disabled>{t("common.next")}</MuiButton>}
                    </Container>
                    </TabPanel>
                     {/* おすすめタブ */}
                     {isMe || loginInfo.userId === undefined ? "" : <TabPanel value={value} index={1}>
                        <Card sx={{ backgroundColor: 'rgba(255,255,255,0.5)' }}>
                           
                            <CardContent>
                                <ImageList cols={{ xs: 2, md: 3, lg: 4 }} gap={8}>
                                    {osusumeImageList.map((data,i) => {
                                            if(i === 100 || data.favorite === 1){
                                                return ""
                                            }
                                    return <Thumb data={data} i={i} dialog={dialog} key={i} userInfoHidden={true} list={osusumeImageList} listName={userInfo.user_name} />
                                    })}
                                </ImageList>
                            </CardContent>
                        </Card>
                    </TabPanel>}
                    {/* キャラクタータブ */}
                    <TabPanel value={value} index={2}>
                         <MuiButton variant='outlined' className='mb-4' onClick={() => setCharacterPage(1)}>1ページ目へ</MuiButton>
                        <Grid container spacing={2}>
                             {characterList.map((d,i) => {
                                if(i === 100) return ""
                                return <CharacterProfileCard data={{display_id:d.display_id,group_id:d.group_id,user_id:d.user_id,follow:d.follow,user_name:d.user_name,description:d.description,character_name:d.character_name,character_name_kana:d.character_name_kana}} />
                            })}
                        </Grid>
                        <Container className='d-flex justify-content-between' style={{width:"200px"}}>
                            {characterPage > 1 ? (
                                    <MuiButton variant='contained' onClick={() => {
                                        let p = page - 1
                                        setCharacterPage(p)
                                        //navigate("/user/" + userId + "/" + order + "/" + p)
                                        getCharacterList(userId,order,p)
                                    } }>{t("common.prev")}</MuiButton>
                                ) : <MuiButton variant='contained' disabled>{t("common.prev")}</MuiButton>}
                            {characterList.length > 100 ? (
                                    <MuiButton variant='contained' onClick={() => {
                                        let p = page + 1
                                        setCharacterPage(p)
                                        //navigate("/user/" + userId + "/" + order + "/" + p)
                                        getCharacterList(userId,order,p)
                                    } }>{t("common.next")}</MuiButton>
                                ) : <MuiButton variant='contained' disabled>{t("common.next")}</MuiButton>}
                         </Container>
                    </TabPanel>
                    {/* シリーズタブ */}
                    <TabPanel value={value} index={3}>
                     {loginInfo.result && userInfo.user_id === loginInfo.userId ? (
                        <MuiButton variant='contained' onClick={() => {
                            setSeriesId()
                            setShowSeriesEdit(true)
                        }}>{t("series.add")}</MuiButton>
                    ) : ""}
                        <Grid container spacing={3}>
                        {seriesList.map((d,i) => {
                             let ageLimit = ["全年齢","PG12","R15","R18","R18G"]
                             let id = d.info.display_id.length > 0 ? d.info.display_id : d.info.user_id
                            return <Grid item xs={12} md={6} lg={6} xl={4} key={i}>
                                        <Paper elevation={3} sx={{  borderRadius: 2, p: 2}}>
                                            <div style={{position:"relative"}}>
                                            {loginInfo.userId === userInfo.user_id ? (
                                                    <div>
                                                        <Button variant='secondary'
                                                            onClick={() => {
                                                                setSeriesId(d.info.series_id)
                                                                setShowSeriesEdit(true)
                                                            }}
                                                        style={{position:"absolute",right:"60px",top:"10px"}}>{t("common.edit")}</Button>
                                                        <Button variant='secondary'
                                                            onClick={() => {
                                                                deleteSeries(d.info.series_id).then(r => {
                                                                    if(r.result){
                                                                        dialog(t("common.confirm"),t("common.deleted"))
                                                                        seriesUpdateHandler()
                                                                    } else {
                                                                        dialog(t("common.error"),r.errors)
                                                                    }
                                                                })
                                                            }}
                                                        style={{position:"absolute",right:"10px",top:"10px"}}><Icon.TrashFill /></Button>
                                                    </div>
                                                ) : ""}
                                                 <Link to={"/series/"+id+"/"+d.info.series_link}>
                                                    <img
                                                        src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/series/"+d.info.series_id+".webp?"+d.info.update_datetime}
                                                        alt={`シリーズ ${i + 1}`}
                                                        style={{ width: '100%', height: 192, objectFit: 'cover', borderRadius: 2, marginBottom: 2 }}
                                                        data-type="series" data-observe="0" data-no={i} className="lazy" loading="lazy"
                                                    />
                                                </Link>
                                            </div>
                                            <Typography fontWeight="bold" variant="h6" mb={1}>{d.info.series_name}</Typography>
                                                <Typography color="grey.600">{parse(d.info.series_description.substring(0,50).replace(/\r|\n|\r\n/g,"<br/>"),{})}  </Typography>
                                                <Typography color="grey.600">年齢制限：{ageLimit[d.info.series_age_limit-1]} </Typography>
                                        </Paper>
                                    </Grid>
                            })}
                            </Grid>
                    </TabPanel>
                    {/* 交流タブ */}
                    <TabPanel value={value} index={4}>
                         <Container style={{display:loginInfo.userId === userId ? "block" : "none"}}>
                        <div style={{display:"inline-block",border:"1px solid #AAAAAA",borderRadius:"5px",textAlign:"left",padding:"10px 5px",marginBottom:"10px"}}>
                            <FormControl fullWidth>
                                 <TextField
                                    label={t("community.textarea")}
                                    multiline
                                    rows={4}
                                    id='text'
                                    className='mb-3 w-100'
                                    style={{lineHeight:"20px"}}
                                />
                                </FormControl>
                             
                            <input type="file" encType="multipart/form-data" accept=".jpg,.jpeg,.gif,.png,.webp" className='d-none' id="file" onChange={(e) => {
                                if(e.currentTarget.files.length > 0){
                                    ImageUtil.loadImage(e.currentTarget.files,setCommunityImage,false)
                                }
                            }} />
                             <Container id="img-area" style={{width:"300px"}}>
                                {communityImage !== "" ? (<img src={communityImage} style={{objectFit:"contain",width:"100%",height:"100%",boxSizing:"content-box"}} />):""}
                            </Container>
                             <Container>
                                <MuiButton  variant="contained" onClick={() => {
                                    setOkButtonShow(false)
                                    let text = document.getElementById("text")
                                    let files = document.getElementById("file").files
                                    if(text.value.trim().length === 0){
                                        dialog("エラー","本文を入力して下さい。")
                                        return
                                    }
                                    if(text.value.trim().length > 2500){
                                        dialog("エラー","本文は2500文字以内にして下さい。")
                                        return
                                    }
                                    if(files.length !== 0){
                                        // ファイルサイズチェック
                                        if(files[0].size > 31457280){
                                            dialog("エラー","ファイルサイズ上限は30MBです。")
                                            return
                                        }
                                    }
                                    upload(document.getElementById("file").files)
                                }}>投稿</MuiButton>
                                <ImageIcon style={{cursor:"pointer",marginLeft:"10px"}} onClick={() => document.getElementById("file").click()} />
                            </Container>
                        </div>
                        <Divider className='mt-2 mb-2'/>
                    </Container>
                        <Container>
                        {communityMessage}
                            {communityImageList.map((d,i)=>{
                                return (
                                <div style={{width:"360px",border:"1px solid #AAAAAA",borderRadius:"5px",textAlign:"left",padding:"10px",marginBottom:"10px"}} key={i}>
                                    <Box display="flex" >
                                        <Box>
                                        <img loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+"_s.jpg"} style={{width:"50px",height:"50px",borderRadius:"25px",marginRight:"30px"}} />
                                         </Box>
                                        <Box style={{position:"relative"}}>
                                        {(loginInfo.userId === d.user_id)? (
                                                <IconButton style={{position:"absolute",zIndex:"1",top:"0px",right:"20px",fontSize:"12px"}} onClick={()=>{
                                                    selectItem({type:"community_image",id:d.group_id})
                                                    setOkButtonShow(true)
                                                    dialog("確認","削除しますか？")
                                                }}><Icon.TrashFill/></IconButton>
                                            ) : ""}
                                             <Typography  style={{fontSize:"14px",marginBottom:"5px"}}>{d.user_name}</Typography>
                                            <Typography  style={{whiteSpace: "pre-wrap"}}>{d.text}</Typography>
                                            <Container style={{width:"100%",margin:"auto"}}>
                                            <img data-type="community" data-no={i} className="lazy" loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/community/t/'+(d.id)+'.jpg'} style={{objectFit:"contain",width:"100%",cursor:"pointer"}} onClick={() => navigate("/post/"+d.group_id)} />
                                            </Container>
                                            <Container>
                                                <FavoriteIcon style={{cursor:"pointer"}} type="community" id={d.group_id} favorite={d.favorite} dialog={dialog} />
                                                <Icon.ChatRightText style={{cursor:"pointer"}} onClick={() => navigate("/post/"+d.group_id)} />
                                                 {d.favorite_count !== 0 ? d.favorite_count : ""}
                                            </Container>
                                        </Box>
                                    </Box>
                                </div>
                                )
                            })}
                        </Container>
                    </TabPanel>
                     {/* プランタブ */}
                     {userInfo.user_id !== loginInfo.userId && userInfo.id_auth === 1 || userInfo.user_id === loginInfo.userId ? (
                          <TabPanel value={value} index={5}>
                            <Container className='mb-4'>
                            {loginInfo.result && userInfo.user_id === loginInfo.userId ? (
                                <MuiButton variant='contained' onClick={() => {
                                    navigate("/manage/plan/new")
                                }} disabled={loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0}>{t("plan.create")}</MuiButton>
                            ) : ""}
                            {userInfo.user_id === loginInfo.userId
                                && (loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0) ? (
                                <Alert severity='info' className='mt-3 mb-3'>
                                    {t("plan.info1")}<br /><br />
                                    <MuiButton onClick={() => setShowSetting(true)} variant='outlined' className='mb-1'>{t("setting.open")}</MuiButton><br />
                                    {t("plan.info2")}<br />
                                    <MuiButton variant='outlined' onClick={() => navigate("/manage/payouts")} className='mt-3'>{t("plan.info3")}</MuiButton><br /><br />
                                </Alert>
                            ) : ""}
                        </Container>
                        <Container>
                            {userInfo.user_id !== loginInfo.userId &&
                                (planStatus.pg12 && loginInfo.pg12_display_flag === 2
                                || planStatus.r15 && loginInfo.r15_display_flag === 2 && loginInfo.age15 === 1
                                || planStatus.r18 && loginInfo.r18_display_flag === 2 && loginInfo.age18 === 1
                                || planStatus.r18g && loginInfo.r18g_display_flag === 2 && loginInfo.age18 === 1)
                            ? (
                                <Alert severity='info'>
                                   {t("plan.info4")}<br />
                                    <MuiButton onClick={() => setShowSetting(true)} variant='outlined'>{t("setting.title")}</MuiButton>
                                </Alert>
                            ) : ""}
                            <div className='mb-5 mt-3' style={{fontFamily:"Meiryo UI",fontSize:"24px",fontWeight:"bold"}}>{t("plan.list")}</div>
                            <Grid container spacing={2}>
                            {planList.map((d,i) => {
                                return <Plan key={i} data={d} />
                            })}
                            </Grid>
                        </Container>
                         </TabPanel>
                     ) : ""}
                    {/* 統計タブ */}
                    <TabPanel value={value} index={6}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Card sx={{ backgroundColor: 'rgba(255,255,255,0.5)' }}>
                                    <CardHeader title={<Typography variant="h6" fontWeight="medium">{t("trackRecord.activity")}</Typography>} />
                                    <CardContent>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                            {[
                                                { label: t("trackRecord.pvTotal"), value: (pvAllCount || "").toLocaleString(), growth: '' },
                                                { label: t("trackRecord.pv3Month"), value:  (pv3MonthCount || "").toLocaleString() + '('+ t("trackRecord.rank")+'：'+(pv3MonthRank || "").toLocaleString()+')', growth: '' },
                                                { label: t("trackRecord.favoriteTotal"), value: (favoriteCount || "").toLocaleString(), growth: '' },
                                                { label: t("trackRecord.favorite3Month"), value:  (favorite3MonthCount || "").toLocaleString(), growth: '' },
                                                { label: t("trackRecord.favoritedCount"), value: (favoritedCount || "").toLocaleString(), growth: '' },
                                                { label: t("trackRecord.getPoint"), value:  (postGetPoint || "").toLocaleString() + t("trackRecord.getPointUnit"), growth: '' },
                                                { label: t("trackRecord.hasPoint"), value:  (point || "").toLocaleString(), growth: '' },
                                                { label: t("trackRecord.totalPointUsed"), value: (totalPointsUsed || "").toLocaleString(), growth: '' },
                                                 { label: t("trackRecord.imageGenerationCount"), value: (imageGenrationCount || "").toLocaleString(), growth: '' },
                                                 { label: t("trackRecord.basePoint"), value: (basePoint || "").toLocaleString(), growth: '' },
                                                 { label: t("trackRecord.numberOfUnitsUnderOperation"), value: (numberOfUnitsUnderOperation || "").toLocaleString(), growth: '' },
                                            ].map((stat, i) => (
                                                <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2, backgroundColor: 'rgba(255,255,255,0.5)', borderRadius: 1 }}>
                                                    <Typography color="grey.600" >{stat.label}</Typography>
                                                    <Box textAlign="right">
                                                        <Typography variant="h6" fontWeight="bold">{stat.value}</Typography>
                                                        <Typography variant="body2" color="success.main">{stat.growth}</Typography>
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                         <MuiButton variant='outlined' onClick={() => {
                                            setShowUserAchievements(false)
                                            setShowRankingRecord(true)
                                        }}>{t("rankingRecord.title")}</MuiButton>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Card sx={{ backgroundColor: 'rgba(255,255,255,0.5)' }}>
                                    <CardHeader title={<Typography variant="h6" fontWeight="medium">{t("common.recentActivity")}</Typography>} />
                                    <CardContent>
                                        <List>
                                            {[...Array(4)].map((_, i) => (
                                                <ListItem key={i} sx={{
                                                    backgroundColor: 'rgba(255,255,255,0.5)',
                                                    borderRadius: 1,
                                                    mb: 1
                                                }}>
                                                    <ListItemAvatar>
                                                        <Avatar sx={{ backgroundColor: 'rgba(100,150,255,0.1)' }}>
                                                            <Heart style={{ color: 'primary.main' }} />
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        primary={<Typography variant="body2" fontWeight="medium">{t("trackRecord.activityLike")}</Typography>}
                                                        secondary={<Typography variant="caption" color="grey.500">2時間前</Typography>}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </TabPanel>
                </Paper>
            </Box>
            <Footer />
        </Box>
    );
};
import { TextField } from '@mui/material';
import { Container } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

export default UserProfile3;